module.exports = __webpack_public_path__ + "Fashion92@2x.png?b17a0db48ac0c1e43939159ddf6fc2a7";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Fashion92@2x.png
// module id = 162
// module chunks = 0